export const audit = {
  settings: "/products/audit/settings/",
  overview: "/products/audit/overview/",
  payoutReport: "/products/audit/payout-report/",
  taxReport: "/products/audit/tax-report/",
  storeAnalytics: "/products/audit/store-analytics/",
};
